module.exports = __webpack_public_path__ + "img/logo.7375fe07.svg";